import { useTranslation } from 'react-i18next';
import { CrosswalkForm } from './CrosswalkForm/CrosswalkForm';
import { useSelectedCrosswalk } from './useSelectedCrosswalk';
import { Box, Button } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(({ spacing }) => {
  return createStyles({
    formWrapper: {
      paddingBottom: spacing(3),
    },
  });
});

export default useStyles;

const NEW_CROSSWALK_ID = 'newCrosswalk';

export const NewCrosswalkForm = () => {
  const { t } = useTranslation('locations');
  const classes = useStyles();
  const { selectedCrosswalk, setSelectedCrosswalk } = useSelectedCrosswalk();
  const isOpen = selectedCrosswalk?.id === NEW_CROSSWALK_ID;

  const handleAdd = () => {
    setSelectedCrosswalk({ id: NEW_CROSSWALK_ID });
  };

  const handleClose = () => {
    setSelectedCrosswalk(undefined);
  };

  return (
    <Box className={classes.formWrapper}>
      <Button onClick={handleAdd} color='secondary' variant='outlined'>
        {t('newCrosswalk')}
      </Button>
      {isOpen ? <CrosswalkForm isNew onClose={handleClose} /> : null}
    </Box>
  );
};
